import cn from "classnames"
import Image from "components/Image"
import Link from "next/link"
import { useCallback, useEffect, useRef, useState } from "react"
import BurgerBtn from "./BurgerBtn"
import styles from "./Header.module.scss"
import Logo from "./Logo"
import Menu from "./Menu"
import Navigation from "./Navigation"

const Header = (props) => {
  const { navs, partner, locale } = props
  const localePrxy = locale === "digital" ? "technology" : locale
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const [animationType, setAnimationType] = useState("soft")
  const scrollPosition = useRef(0)

  const pageSuffix = localePrxy !== "disphere" ? ` ${localePrxy}` : ""
  const toggleMenu = useCallback(
    (state) => {
      setIsMenuOpen((prevIsMenuOpen) => {
        if (!prevIsMenuOpen) {
          scrollPosition.current = document.documentElement.scrollTop
        }
        return typeof state !== "undefined" ? state : !isMenuOpen
      })
    },
    [isMenuOpen]
  )

  const toggleSoft = useCallback(
    (state) => {
      setAnimationType("soft")
      toggleMenu(state)
    },
    [toggleMenu]
  )

  const toggleHard = useCallback(
    (state) => {
      setAnimationType("hard")
      toggleMenu(state)
    },
    [toggleMenu]
  )

  const toggleMenuFn = (animationType = "hard") => {
    if (animationType === "soft") {
      toggleSoft()
    } else {
      toggleHard()
    }
  }

  useEffect(() => {
    if (typeof document !== "undefined" && isMenuOpen) {
      document.querySelector("body").classList.add("menu-open")
    } else {
      document.querySelector("body").classList.remove("menu-open")
    }

    const nav = document
      .getElementById("main-navigation")
      ?.getBoundingClientRect()
    const isNavVisible = !nav || (!nav.x && !nav.width)

    if (isNavVisible) {
      if (isMenuOpen) {
        document.documentElement.scrollTo(0, 0)
      } else {
        document.documentElement.scrollTo(0, scrollPosition.current)
      }
    }
  }, [isMenuOpen])

  useEffect(() => {
    function handleKeyboardEvent(event) {
      const eventKeyCode = event.which || event.keyCode
      if (eventKeyCode === 27) {
        toggleSoft(false)
      }
    }

    if (typeof document !== "undefined" && isMenuOpen) {
      document.addEventListener("keyup", handleKeyboardEvent, false)
    }
    return function cleanup() {
      if (typeof document !== "undefined") {
        document.removeEventListener("keyup", handleKeyboardEvent, false)
      }
    }
  }, [isMenuOpen, toggleSoft])

  return (
    <>
      <header
        className={cn(styles.header, {
          [styles.hasNav]: Boolean(navs),
        })}
      >
        <div className={styles.inner}>
          <Link href="/">
            <a
              aria-label={`disphere${pageSuffix} GmbH: Zur Startseite`}
              className={styles.logo}
            >
              <Logo />
            </a>
          </Link>
          {partner ? (
            <div className={styles.partner}>
              {partner &&
                partner.length > 0 &&
                partner.map((partner, i) => {
                  return (
                    partner.logo && (
                      <li key={i} className={styles.imageWrapper}>
                        <Image
                          className={styles.image}
                          src={partner.logo.permalink}
                          alt={partner.logo.alt}
                          width={partner.logo.width}
                          height={partner.logo.height}
                        />
                      </li>
                    )
                  )
                })}
            </div>
          ) : (
            <div className={styles.nav}>
              <Navigation {...props} toggleMenuFn={toggleMenuFn} />
              <BurgerBtn className={styles.burger} onClick={toggleMenuFn} />
            </div>
          )}
        </div>
      </header>
      <Menu
        navs={navs}
        isOpen={isMenuOpen}
        animationType={animationType}
        toggleMenuFn={toggleMenuFn}
        pageSuffix={pageSuffix}
      />
    </>
  )
}

export default Header
